import { config } from "config.js";
let BASE_URL = "";
let BASE_URL_CMS = "";
let s3url = "";
let ssoUrl = "";
let cdnUrl = "";
let isIndexSharded = false;

if (config["state"] == "PROD") {
  isIndexSharded = true;
  BASE_URL = config["prodJavaURL"];
  BASE_URL_CMS = config["prodJavaURLCMS"];
  s3url = config["prodS3"];
  ssoUrl = config["prodSSO"];
  cdnUrl = config["prodcdnUrl"];
} else if (config["state"] == "STAGING") {
  isIndexSharded = false;
  BASE_URL = config["stagingJavaURL"];
  BASE_URL_CMS = config["stagingJavaURLCMS"];
  s3url = config["stagingS3"];
  ssoUrl = config["stagingSSO"];
  cdnUrl = config["cdnUrl"];
} else {
  isIndexSharded = false;
  BASE_URL = config["devJavaURL"];
  BASE_URL_CMS = config["devJavaURLCMS"];
  s3url = config["devS3"];
  ssoUrl = config["devSSO"];
  cdnUrl = config["cdnUrl"];
}
export { BASE_URL_CMS, BASE_URL, ssoUrl, s3url, cdnUrl, isIndexSharded };

export const LOG_IN = "login/v2";
export const LOG_OUT = "logout";
export const GET_USER_INFO = "singleUser";
export const GET_PHX_USER_DETAILS = "users/phxDetails";
export const GET_CLASS = "classes";
export const GET_ACAD_YEAR = "academicYears";
export const GET_DOCUMENT_TYPE = "documentType/view";
export const GET_STREAMS = "streams";
export const GET_BRANCH =
  "branch?limit=1000&offset=0&sortBy=branchName&sortDir=ASC";
export const GET_STATE = "states?limit=1000&offset=0";
export const REGISTER_USER = "register/user";
export const SERVICE_REQUEST = "service/request";
export const GET_SERVICE_REQUEST_LIST = "service/requestList";
export const STUDENT_SEARCH = "student/search?";
export const GET_COMMENTS_LIST = "comment?";
export const GET_FAQ_DATA = "helpCenter?";
export const POST_COMMENT = "comment";
export const UPDATE_COMMENT = "comment";
export const DELETE_COMMENT = "comment";
export const GET_PLANNER_VIEW_LIST = "document";
export const GET_SUBJECTS = "subjects";
export const GET_PHASE = "phase";
export const ADD_DOCUMENT = "document";
export const ADD_DOCUMENT_TYPE = "documentType/save";
export const GET_PLANNER_DECRPTION_KEY = "document/getLicense?documentId=";
export const CHAT_LIST1 =
  "https://dcb22cfd-34d6-45d0-8f55-4e5bcbd06880.mock.pstmn.io/chatList";
export const CHAT_LIST2 =
  "https://9afde4ba-8c65-4210-90a0-91abcae77e0e.mock.pstmn.io/chatlist";
export const TESTPERFORMANCE = "student/performance?";
export const TESTPERFORMANCE_SUBJ =
  "https://77ec38eb-1649-4cbb-88ed-4b7a61c80b38.mock.pstmn.io/testPerformance";
export const SYLLABUS_COMPLIANCE_LIST = "syllabusCompliance/mySchedule";
export const MY_BATCHES_LIST = "syllabusCompliance/myBatch";
export const NOT_MARKED_COMPLIANCE = "syllabusCompliance/mySchedule/notMarked";
export const ALL_COURSE = "syllabusCompliance/course/toc";
export const COVERED_TOPIC_NODES = "syllabusCompliance/lecture/getNodesMarked";
export const POST_COVERED_SYLLABUS = "syllabusCompliance";
export const BATCH_COURSE_PL_NODE = "syllabusCompliance/batchCourseNodePL";
export const GET_BOARD = "boards";
export const GET_SYLLABUSMATER = "user/allSyllabus";
export const GET_USER = "users/filter";
export const GET_LISTALLCHAPTERNODES = "chaptersOfSyllabusMaster";
export const GET_CHAPTERCONTENTDATBYID = "chapterContents";
export const GET_MASTER_TAGS = "asset/masterTags";
export const GET_VIDEO_URL = "asset/getVideoUrl";
export const GET_SIGNED_URL = "asset/getSignedURL";
export const GET_CONTENT_LICENCE = "asset/getLicense";
export const POST_CREATE_USER = "createUser";
export const SINGLE_USER = "users";
export const UPDTAE_SINGLE_USER = "updateUser";
export const FACULTY_SEARCH = "users/search";
export const FETCH_REGION = "region";
export const FETCH_LOP_REGIONS = "lop/getLopReasons";
export const FETCH_LOP_ACTIONS = "lop/getLopActions";
export const MY_BRANCH_LIST = "lop/filter";
export const MY_BRANCH_STUDENT_LIST = "lop/students";
export const MY_BRANCH_AGGREGATED_DATA = "lop/getAggregated";
export const GET_ATTENDANCE_COUNT = "attendace/getAttendanceCount";
export const FETCH_ATTENDANCE_DATA = "attendace/getMonthWise";
export const PLANNED_LECTURES_NODES = "syllabusCompliance/course/toc";
export const PLANNED_LECTURE_LIST = "syllabusCompliance/plannedLecture";
export const GET_TEST_TYPE = "testTypes";
export const SYLLABUS_COMPLIANCE_BATCHES = "syllabusCompliance/batches";
export const GET_FACULTY_SEARCH = "faculty/search";
export const GET_TESTSYLLABUS_STATUS =
  "syllabusCompliance/getTestSyllabusStatus";
export const GET_ASSETS_WITH_SM_ID = "syllabusCompliance/lecture/getAssets";
export const GET_CHAPTER_NODE_DETAILS = "syllabusCompliance/chapterNodeDetail";
export const GET_BATCHPL_STATUS = "syllabusCompliance/getBatchPLStatus";
export const GET_LECTURE_DETAIL = "syllabusCompliance/batch/lectures";
export const GET_NONLECTURE_DETAIL =
  "syllabusCompliance/batch/nonSyllabusEvents";
export const GET_BATCH_DETAILS = "syllabusCompliance/batchDetails";
export const GET_BATCH_STUDENT_DETAILS =
  "syllabusCompliance/getBatchStudentsDetail";
export const GET_BATCH_TEST_DETAILS = "syllabusCompliance/batchTests";
export const GET_TESTSYLLABUS = "syllabusCompliance/getTestSyllabus";
export const GLOBAL_SEARCH = "search";
export const FacultyPerformance = "facultyPerformance/view";
export const GetViewDocumentURL = "document/getUrl";
export const CREATE_NOTIFICATION = "notify";
export const GET_NOTIFICATION = "notify";
export const GET_NOTIFICATION_STATUS = "notify/getNotifyStatus";
export const GET_STUDENT_ATTENDANCE = "attendace/presentStudents";
export const POST_MARK_ATTENDANCE = "attendace/markAttendance";
export const GET_FACULTY_PERFORMANCE_SEARCH = "facultyPerformance/filter";
export const MARK_STUDENT_ISSUE_REPORT = "attendace/resolve/attendanceIssue";
export const EXTERNAL_TESTPLAYER_URL = "student/getTestPlayerExamUrl";
export const USER_NOTIFICATIONS = "notify/getFacultyNotification";
export const DELETE_FLAG_STUDENT_FROM_REPORT = "attendace/deleteFlagStudent";
export const FETCH_STUDENT_PACKAGE = "student/packages";
export const FETCH_STUDENT_COURSE = "student/course";
export const FETCH_STUDENT_CONTENT_VIEW = "student/chapter";
export const GET_BATCH_COURSES_CHAPTER_VIEW =
  "syllabusCompliance/getBatchCoursesChapterView";
export const REFRESH_PLANNED_LECTURES =
  "syllabusCompliance/refreshPlannedLectures";
export const GET_STUDENT_INSIGHT = "student/getInsights";
export const POST_INSIGHT_FEEDBACK = "student/saveInsightsFeedback";
export const STUDENT_SEARCH_HISTORY = "searchHistory";
export const STUDENT_SEARCH_TAB = "searchHistory/studentDetails";
export const fetchPresignedUrl = "uploadLectureMedia";
export const uploadCallbackUrl = "uploadLectureMedia/callBack";
export const fetchUploadedAssetOnLecture = "uploadLectureMedia";
export const deleteUploadedAssetOnLecture = "uploadLectureMedia";
export const DOWNLOAD_MEDPRO_URL = "testPdf/generate";
export const GET_STUDENT_KUNDALI = "student/concept-kundali";
export const DEVELOPER_LECTUREACCESS = "developer/lectureAccess";
export const CREATE_LOP_REGIONS = "developer/lop-reasons";
export const STUDENT_HTML_URL = "medprolite/student/subjects/";
export const Doubts_GetAllDoubts = "doubts";
export const GegenerateSolution = "doubts/regenerateSolution";
export const GET_CARD_ANALYTICS = "doubts/getCardAnalytics";
export const Generate_PresignedUrl = "doubts/generatePresignedUrl";
export const GET_QUESTION_DETAIL = "doubts/claim";
export const GENERATE_AI_SOLUTION = "doubts/regenerateSolution";
export const SAVE_SOLUTION = "doubts/saveSolution";
export const VIEW_QUESTION = "doubts/viewQuestion/";
export const REJECT_DOUBT = "doubts/reject";
export const SKIP_QUESTIONS = "doubts/skipQuestions";
export const DRS_DASHBOARD = "drs-dashboard";
export const QUIZ_LIST = "quiz/lecture";
export const QUIZ = "quiz";
export const QUESTION_AUTO_PICK = "question/v2/pick";
export const GET_EXAM = "exams";
export const SEARCH_SIMILAR_QUESTIONS = "doubts/search";
export const QUIZ_LIMIT = "developer/quiz-limits";
export const QUIZ_LIMIT_2 = "quiz-limits";
export const DEVELOPER_COMMON_CONFIG = "developer/common-configuration";
export const GET_CONFIG_FEATURE =
  "common-configuration/get-config-by-feature-key?featureKey=";
export const GET_CONFIG__BY_CONFIG_KEY =
  "common-configuration/get-config-by-feature-and-config-key?featureKey=";
export const QUIZ_VALIDATION_LIMIT = "QUIZ_VALIDATION_LIMIT";
export const DRS_DOUBT_SKIP = "DRS_DOUBT_SKIP";
export const DRS_SKIP_QUESTION_REASON = "DRS_SKIP_QUESTION_REASON";
export const DRS_DOUBT_REJECT = "DRS_REJECT";
export const DRS_REJECT_QUESTION_REASON = "DRS_REJECT_QUESTION_REASON";
export const GET_UNREAD_COMMENTS = "unreadPostComments";
